import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { Delimiter } from '../../../../../../components';
import { CloseWrapper } from '../../helpers';

export const DelimiterNodeView: FunctionComponent<NodeViewProps> = ({ editor, node, getPos }) => {
  return (
    <NodeViewWrapper as={'div'}>
      <CloseWrapper editor={editor} node={node} getPos={getPos}>
        <Delimiter />
      </CloseWrapper>
    </NodeViewWrapper>
  );
};
